import React from 'react';
import { Modal, Button, Text } from '@unimed-fesp/components';

import { Container } from './styles';

const ModalTrigger = ({ tipo, message, callback, closeModal, Footer }) => {
  const onClickModal = () => {
    callback();
    closeModal();
  };

  const isJsxElement = React.isValidElement(message);

  return (
    <Container>
      <Modal
        tipo={tipo}
        isOpen
        onClick={onClickModal}
        footer={
          Footer ? (
            <Footer closeModal={closeModal} />
          ) : (
            <DefaultFooter onClick={onClickModal} />
          )
        }
      >
        {isJsxElement ? message : <Text text={message} center />}
      </Modal>
    </Container>
  );
};

const DefaultFooter = ({ onClick }) => (
  <Button
    onClick={onClick}
    marginRight={14}
    type="button"
    justifyCenter
    alignCenter
    width={121}
    font="16px unimed_slabregular"
  >
    ok
  </Button>
);

export default ModalTrigger;
